export interface IRemoteOrderGroupEntryService {
  /** Determines if the user is already a member of this or another group */
  membershipStatus(groupid: number): Promise<RemoteGroupMember>;
  /** Retrieves information about the group code */
  getGroupInfo(groupId: number): Promise<IRemoteGroupCodeInfo>;
  /** Checks if the nickname is valid. joinGroup then checks if the name is duplicated */
  checkNickname(nickname: string): Promise<boolean>;
  /** Attempts to join the group code */
  joinGroup(nickname: string, location: number, group_name: string, groupId: number): Promise<EntryGroupResult>;
}

/** Membership status in the group */
export enum RemoteGroupMember {
  /** Is not a member of the group */
  Not,
  /** Is already a member of the group */
  Yes,
  /** unknown */
  Unknown
}

/** Information about the requested group code */
export interface IRemoteGroupCodeInfo {
  /** Group name and creator name */
  readonly groupInfo: IRemoteGroupInfo;
  /** Group is valid */
  readonly valid: boolean;
  /** Group is full, no space available */
  readonly isFull: boolean;
  /** Location */
  readonly location: number;
}

export interface IRemoteGroupInfo {
  /** Group Id */
  readonly groupId: number;
  /** Group name */
  readonly groupName: string;
  /** Group creator name */
  readonly groupCreator: string;
  /** Selected Delivery/Order time */
  readonly selectedServiceTime?: string;
  /** selected order end time */
  readonly selectedOrderTime?: string;
  /** Delivery address */
  readonly groupDeliveryAddress?: string;
  /** Pickup address */
  readonly pickUpAddress?: string;
  /** Group delivery/pickup */
  readonly orderType?: number;
}

/** Join result */
export enum EntryGroupResult {
  /** User is already assigned to a group */
  UserIsInGroup,
  /** Successfully assigned user to the group */
  Okay,
  /** Failed to assign user to the group */
  Fail,
  /** Username is incorrect, taken, or blocked */
  WrongUserName,
  /** User could not join the group, group has reached its limit */
  GroupFull,
  /**member could not be created */
  PlaceUndefined,
}